import { useIntl } from 'react-intl';

import { getDataReliabilityAccuracyPath } from '@verantos-dev/core-constants';
import { DataReliabilityPageTab } from '@verantos-dev/core-enums';
import { PageHeaderBreadcrumb } from '@verantos-dev/shared-components';
import { type PageTabProps } from '@verantos-dev/shared-components';

// TODO: cleanup with data_reliability ff — Data Reliability is a top-level,
// project-independent page, so the header carries no project breadcrumb trail.
export const useDataReliabilityPageHeader = (): {
  breadcrumbs: PageHeaderBreadcrumb[] | undefined;
  pageTabs: PageTabProps[];
  messages: { [key: string]: string };
} => {
  const intl = useIntl();

  const messages = {
    pageTitle: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.breadcrumbs.dataReliability',
    }),
    accuracyTitle: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.pageTabs.accuracy',
    }),
    accuracyDesc: intl.formatMessage({
      id: 'dataReliability.dataReliabilityPage.pageTabs.accuracyDesc',
    }),
  };

  const breadcrumbs: PageHeaderBreadcrumb[] | undefined = undefined;

  const pageTabs: PageTabProps[] = [
    {
      id: DataReliabilityPageTab.accuracy,
      label: DataReliabilityPageTab.accuracy.toUpperCase(),
      isActive: true,
      path: getDataReliabilityAccuracyPath(),
      disabled: false,
    },
    {
      id: DataReliabilityPageTab.completeness,
      label: DataReliabilityPageTab.completeness.toUpperCase(),
      isActive: false,
      path: '',
      disabled: true,
    },
    {
      id: DataReliabilityPageTab.traceability,
      label: DataReliabilityPageTab.traceability.toUpperCase(),
      isActive: false,
      path: '',
      disabled: true,
    },
  ];

  return {
    breadcrumbs,
    pageTabs,
    messages,
  };
};
